module.exports = __webpack_public_path__ + "media/images/emblems/Brienz-coat_of_arms-3732358f347c2428db6940d1001cf3a4.svg";